<div
  class="justify-between items-center"
  [innerHtml]="altHeader"
  *ngIf="altHeader && showHeader && onlyMessage"
  style="width: 100%; display: flex; justify-content: space-around"
></div>
<div
  class="sticky-container"
  *ngIf="(secondScreen || endScreen || showAppointmentsScreen) && onlyMessage"
>
  <div class="container">
    <div
      class="m-box"
      style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center"
      #messageGeneral
      *ngIf="showMessageGeneral"
    >
      <div class="w100" style="display: flex; flex-direction: column; align-items: center">
        <textarea
          style="border: 1px solid rgba(0, 0, 0, 0.2)"
          class="t-field-text w100"
          [(ngModel)]="Message"
          placeholder="ניתן לרשום כאן את ההודעה "
        ></textarea>
        <button class="blue-btn" (click)="leftDetails(true)">שלח וסיים</button>
      </div>
    </div>
  </div>
</div>

<div
  class="sticky-container"
  *ngIf="(secondScreen || endScreen || showAppointmentsScreen) && !onlyMessage"
>
  <div style="display: flex; justify-content: center">
    <button
      *ngIf="secondScreen || endScreen || showAppointmentsScreen"
      (click)="
        savePatientsAbandonedProcesses('without reason');
        endScreen = true;
        secondScreen = false;
        showMessageGeneral = false;
        showAppointmentsScreen = false
      "
      class="orange-btn btn-sticky"
    >
      לסיום
    </button>
    <button
      *ngIf="secondScreen || endScreen || showAppointmentsScreen"
      (click)="onShowMessageGeneral()"
      class="blue-btn btn-sticky"
    >
      להשארת הודעה וסיום
    </button>
    <button
      *ngIf="secondScreen || endScreen || showAppointmentsScreen"
      (click)="onBackButtonClick()"
      class="orange-btn btn-sticky"
    >
      חזור לעמוד קודם
    </button>
  </div>
  <div class="container" *ngIf="showMessageGeneral">
    <div
      class="m-box"
      style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center"
      #messageGeneral
      *ngIf="showMessageGeneral"
    >
      <div class="w100" style="display: flex; flex-direction: column; align-items: center">
        <textarea
          style="border: 1px solid rgba(0, 0, 0, 0.2)"
          class="t-field-text w100"
          [(ngModel)]="Message"
          placeholder="ניתן לרשום כאן את ההודעה "
        ></textarea>
        <button class="blue-btn" (click)="leftDetails(true)">שלח וסיים</button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="popUpMessage" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">
      {{ popUpMessage }}
    </h2>
    <button
      (click)="popUpMessage = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>
<div *ngIf="popupActivityDeviation" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">
      לא ניתן לקבוע תור, למחוק תור או לעדכן תור היום עקב הגעה למכסת הפעולות היומית למטופל. יש ליצור קשר
      עם המרפאה
    </h2>
    <button
      (click)="popupActivityDeviation = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>

<main class="container">
  <ng-container *ngIf="GID">
    <div
      class="justify-between items-center"
      [innerHtml]="altHeader"
      *ngIf="altHeader && showHeader && !onlyMessage"
      style="width: 100%; display: flex; justify-content: space-around"
    ></div>
    <ng-container *ngIf="firstScreen">
      <h1 style="direction: rtl">ברוכים הבאים לזימון התורים של {{ clinicTitle }}</h1>

      <div
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        "
      >
        <div
          class="w100"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            flex-direction: column;
            align-items: center;
          "
        >
          <div style="display: flex; flex-direction: column; align-items: center">
            <label for="patient-id-input" style="margin-left: 0.3em; align-self: center">מה ת.ז שלך?</label>
            <span class="t-field t-field--number" style="direction: rtl">
              <input
                id="patient-id-input"
                [(ngModel)]="ID"
                (ngModelChange)="resetAll()"
                class="t-field-text"
                (keyup.enter)="handleEnter()"
              />
            </span>
          </div>
          <button 
            *ngIf="idAttemptsCounter < 4" 
            class="blue-btn" 
            (click)="resetAll(); searchPatient()"
            [disabled]="isSearchingPatient || resendCodeDisabled">
            {{ isSearchingPatient ? 'מחפש...' : 'המשך' }}
          </button>
        </div>
        <h2 style="margin-top: 10%; color: red" *ngIf="invalidId">
          תז לא תקינה {{ idAttemptsCounter > 3 ? "יש ליצור קשר עם המרפאה" : "" }}
        </h2>
      </div>
      <div
        *ngIf="showMobile"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            flex-direction: column;
          "
        >
          <span style="margin-left: 0.3em; align-self: center">פלאפון </span>
          <span class="t-field t-field--number" style="direction: rtl">
            <input [(ngModel)]="mobile" class="t-field-text" />
          </span>
          <button 
            *ngIf="isValidMobile(mobile)" 
            (click)="IdentityVerification()" 
            class="blue-btn"
            [disabled]="resendCodeDisabled || isSendingCode">
            {{ isSendingCode ? 'שולח קוד...' : 'שלח קוד אימות' }}
          </button>
        </div>
      </div>
      <div *ngIf="showVerification" class="m-box">
        <div
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          "
        >
          <div class="w100" style="display: flex; flex-direction: column">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                flex-direction: column;
              "
            >
              <span
                *ngIf="mobile && mobile.length === 4"
                style="margin-left: 0.3em; align-self: center; text-align: center"
              >
                <ng-container *ngIf="patient.First"> היי {{ patient.First }}, </ng-container>
                אנא הזיני קוד אימות שנשלח לנייד שמסתיים ב {{ mobile }}
              </span>

              <span *ngIf="mobile && mobile.length > 4" style="margin-left: 0.3em; align-self: center"
                >אנא הזיני קוד אימות שנשלח
              </span>

              <span class="t-field t-field--number" style="direction: rtl">
                <input [(ngModel)]="verification" class="t-field-text txt-al-c" #verificationInput />
              </span>
            </div>
            <button
              *ngIf="verification && codeMobileAttemptsCounter < 3"
              class="blue-btn"
              (click)="checkVerification(verification)"
              [disabled]="isCheckingVerification"
            >
              {{ isCheckingVerification ? "מאמתת..." : "המשיכי" }}
            </button>
            <button
              *ngIf="codeMobileAttemptsCounter < 3 && !returningFromSecondScreen"
              class="orange-btn"
              style="margin-top: 1em"
              (click)="patient.PID ? searchPatient() : IdentityVerification()"
              [disabled]="resendCodeDisabled || isSendingCode"
            >
              {{ isSendingCode ? 'שולח קוד...' : (resendCodeDisabled ? 'לא קיבלת קוד אימות? בעוד כ-' + resendCodeTimer + ' שניות תוכלי לשלוח שוב' : 'שלחי קוד אימות שוב') }}
            </button>
          </div>
          <h3 *ngIf="!verificationValid">קוד האימות שהוזן שגוי</h3>
        </div>
        <div
          style="margin-top: 10%; color: red; display: flex; justify-content: space-around"
          *ngIf="codeMobileAttemptsCounter > 2"
        >
          יש ליצור קשר עם המרפאה
        </div>
      </div>
      <div
        *ngIf="mobileError"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="display: flex; align-items: center; justify-content: center; width: 100%"
        >
          <span style="margin-left: 0.3em; align-self: center">
            תז קיימת במערכת אך לא מוזן טלפון. יש לפנות למרפאה</span
          >
        </div>
      </div>

      <div
        *ngIf="showFirstName"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="display: flex; align-items: center; justify-content: center; width: 100%"
        >
          <span style="margin-left: 0.3em; align-self: center">שם פרטי</span>
          <span class="t-field t-field--number" style="direction: rtl">
            <input [(ngModel)]="firstName" class="t-field-text" (ngModelChange)="showLastName = true" />
          </span>
        </div>
      </div>
      <div
        *ngIf="showLastName"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="display: flex; align-items: center; justify-content: center; width: 100%"
        >
          <span style="margin-left: 0.3em; align-self: center">שם משפחה</span>
          <span class="t-field t-field--number" style="direction: rtl">
            <input [(ngModel)]="lastName" class="t-field-text" (ngModelChange)="showBirth = true" />
          </span>
        </div>
      </div>
      <div
        *ngIf="showBirth"
        class="m-box"
        style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;"
      >
        <div class="w100" style="display: flex; align-items: center; justify-content: center; width: 100%;">
          <span style="margin-left: 0.3em; align-self: center; white-space: nowrap;">תאריך לידה *</span>
          <span class="t-field t-field--number" style="direction: rtl;">
            <input type="date" [(ngModel)]="birthDate" class="t-field-text" (ngModelChange)="showAddress = !!birthDate" />
          </span>
        </div>
      </div>
      <div
        *ngIf="showAddress"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: visible;
        "
      >
        <div
          class="w100"
          style="
            display: flex; 
            align-items: center; 
            justify-content: center; 
            width: 100%;
            flex-wrap: wrap;
            gap: 0.5em;
          "
        >
          <div style="display: flex; align-items: center; flex: 1; min-width: 200px; direction: rtl;">
            <span style="margin-left: 0.3em; align-self: center; white-space: nowrap;">עיר </span>
            <span class="t-field t-field--number" style="direction: rtl; position: relative; flex: 1;">
              <input 
                [(ngModel)]="citySearchInput" 
                (input)="onCityInput($event)"
                (blur)="onCityBlur()"
                placeholder="בחר עיר"
                class="t-field-text w100"
                style="position: relative; z-index: 10;"
              />
              <div 
                *ngIf="filteredCities.length > 0 && citySearchInput && citySearchInput.length > 0" 
                style="
                  position: absolute; 
                  top: 100%; 
                  right: 0; 
                  left: 0; 
                  background: white; 
                  border: 1px solid rgba(0, 0, 0, 0.2); 
                  max-height: 200px; 
                  overflow-y: auto; 
                  z-index: 99999;
                  border-top: none;
                "
              >
                <div 
                  *ngFor="let city of filteredCities"
                  (click)="selectCity(city)"
                  style="
                    padding: 0.5em;
                    cursor: pointer;
                    text-align: right;
                    direction: rtl;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                    transition: background-color 0.2s;
                    white-space: nowrap;
                  "
                  (mouseenter)="$event.target.style.backgroundColor = 'rgba(0, 0, 0, 0.05)'"
                  (mouseleave)="$event.target.style.backgroundColor = 'transparent'"
                >
                  {{ city }}
                </div>
              </div>
            </span>
          </div>
          <div style="display: flex; align-items: center; flex: 1; min-width: 200px; direction: rtl;">
            <span style="margin-left: 0.3em; align-self: center; white-space: nowrap;">כתובת </span>
            <span class="t-field t-field--number" style="direction: rtl; flex: 1;">
              <input [(ngModel)]="address" placeholder="רחוב מס.,דירה " class="t-field-text w100" />
            </span>
          </div>
          <div style="display: flex; align-items: center; flex: 1; min-width: 150px;">
            <span style="margin-left: 0.3em; align-self: center; white-space: nowrap;">מיקוד </span>
            <span class="t-field t-field--number" style="direction: rtl; flex: 1;">
              <input [(ngModel)]="Zip" class="t-field-text w100" type="number" />
            </span>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          mobile &&
          firstName &&
          lastName &&
          birthDate &&
          ID
        "
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="display: flex; align-items: center; justify-content: center; width: 100%"
        >
          <button (click)="firstScreen = false; secondScreen = true" class="blue-btn">
            לשמירת הפרטים ומעבר לבחירת סוג התור
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="secondScreen && patActivities < 4 && !onlyMessage">
      <div
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="display: flex; align-items: center; justify-content: center; width: 100%"
        >
          <span style="max-width: 40%"> האם הבדיקה תתבצע במסגרת </span>
          <button
            (click)="setHmo('Private'); orderExamsByCategories()"
            class="blue-btn"
            [ngStyle]="{ opacity: hmo === 'Private' ? '0.7' : '1' }"
          >
            פרטי
          </button>
          <button
            (click)="setHmo('Hmo'); orderExamsByCategories()"
            class="blue-btn"
            [ngStyle]="{ opacity: hmo === 'Hmo' ? '0.7' : '1' }"
          >
            ביטוח קופה
          </button>
        </div>
      </div>
      <div
        *ngIf="hmo == 'Hmo'"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 400px;
          "
        >
          <span style="margin-left: 0.3em; align-self: center">בחר קופת חולים</span>
          <select class="t-select w100" [(ngModel)]="HMOName" (ngModelChange)="orderExamsByCategories()">
            <option value="">בחר</option>
            <option value="Clalit" *ngIf="hmoOptions && hmoOptions.includes('Clalit')">כללית</option>
            <option value="Macabi" *ngIf="hmoOptions && hmoOptions.includes('Macabi')">מכבי</option>
            <option value="Meuhedet" *ngIf="hmoOptions && hmoOptions.includes('Meuhedet')">
              מאוחדת
            </option>
            <option value="Leumit" *ngIf="hmoOptions && hmoOptions.includes('Leumit')">לאומית</option>
          </select>
        </div>
      </div>

      <div
        *ngIf="hmo == 'Hmo' && HMOName"
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class="w100"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 400px;
          "
        >
          <span style="margin-left: 0.3em; align-self: center"> תוכנית ביטוח בקופה </span>
          <select
            class="t-select w100"
            [(ngModel)]="Insurance"
            (ngModelChange)="orderExamsByCategories()"
          >
            <option value="">
              {{ "appointments.gui.selects.Select" | translate | titlecase }}
            </option>
            <ng-container *ngIf="HMOName == 'Clalit'">
              <option value="Platinum">
                {{ "appointments.gui.selects.Platinum" | translate }}
              </option>
              <option value="Mushlam">
                {{ "appointments.gui.selects.Mushlam" | translate }}
              </option>
            </ng-container>
            <ng-container *ngIf="HMOName == 'Macabi'">
              <option value="Sheli">
                {{ "appointments.gui.selects.Sheli" | translate }}
              </option>
              <option value="Zahav">
                {{ "appointments.gui.selects.Zahav" | translate }}
              </option>
              <option value="Kesef">
                {{ "appointments.gui.selects.Kesef" | translate }}
              </option>
              <option value="Basis">
                {{ "appointments.gui.selects.Basis" | translate }}
              </option>
            </ng-container>
            <ng-container *ngIf="HMOName == 'Meuhedet'">
              <option value="Adif">
                {{ "appointments.gui.selects.Adif" | translate }}
              </option>
              <option value="C">
                {{ "appointments.gui.selects.C" | translate }}
              </option>
            </ng-container>
            <ng-container *ngIf="HMOName == 'Leumit'">
              <option value="Zahav">
                {{ "appointments.gui.selects.Zahav" | translate }}
              </option>
              <option value="Kesef">
                {{ "appointments.gui.selects.Kesef" | translate }}
              </option>
            </ng-container>
          </select>
        </div>
      </div>

      <!-- <ng-container *ngIf="hmo === 'Hmo'">
    <div  class="m-box" style="direction: rtl; margin: 1em 0; display: flex; align-items: center; justify-content: center;">
<div class="w100" style="display: flex;flex-direction: column; align-items: center;">
        <h3>נא השאירי הודעה ויצרו קשר בהקדם</h3>
        <textarea style="border: 1px solid rgba(0, 0, 0, 0.2);" class="t-field-text w100" [(ngModel)]="Message" placeholder="ניתן לרשום כאן את ההודעה "></textarea>
        <button   class="blue-btn" (click)="leftDetails()" > לשליחה וסיום</button> 
       </div>
    </div>

</ng-container> -->
      <ng-container *ngIf="hmo == 'Private' || (hmo == 'Hmo' && HMOName && Insurance)">
        <div
          class="m-box"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="display: flex; align-items: center; justify-content: center; width: 100%"
          >
            אנא בחרי סוג בדיקה
            <label class="t-label-top" *ngIf="PregnancyExams.length">
              <input
                type="radio"
                value="Pregnancy"
                class="custom-check -sq"
                name="examCategory"
                [(ngModel)]="examCategory"
                (ngModelChange)="switchExamCategory('Pregnancy')"
              />
              <i class="customInput-display -sq"></i>
              <span>מיילדותית (הריונית)</span>
            </label>
            <label class="t-label-top" *ngIf="GynecologyExams.length">
              <input
                type="radio"
                value="Gynecology"
                class="custom-check -sq"
                name="examCategory"
                [(ngModel)]="examCategory"
                (ngModelChange)="switchExamCategory('Gynecology')"
              />
              <i class="customInput-display -sq"></i>
              <span>גניקולוגית</span>
            </label>
            <label class="t-label-top" *ngIf="FetalEchoExams.length">
              <input
                type="radio"
                value="Fetal Echo"
                class="custom-check -sq"
                name="examCategory"
                [(ngModel)]="examCategory"
                (ngModelChange)="switchExamCategory('Fetal Echo')"
              />
              <i class="customInput-display -sq"></i>
              <span>אקו לב עובר</span>
            </label>
            <label class="t-label-top" *ngIf="PediatricEchoExams.length">
              <input
                type="radio"
                value="Pediatric Echo"
                class="custom-check -sq"
                name="examCategory"
                [(ngModel)]="examCategory"
                (ngModelChange)="switchExamCategory('Pediatric Echo')"
              />
              <i class="customInput-display -sq"></i>
              <span>אקו לב ילדים</span>
            </label>
            <label class="t-label-top" *ngIf="CardioExams.length">
              <input
                type="radio"
                value="Cardio"
                class="custom-check -sq"
                name="examCategory"
                [(ngModel)]="examCategory"
                (ngModelChange)="switchExamCategory('Cardio')"
              />
              <i class="customInput-display -sq"></i>
              <span>קרדיו</span>
            </label>
          </div>
        </div>

        <div
          *ngIf="examCategory == 'Pregnancy' || examCategory == 'Fetal Echo'"
          class="m-box"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="display: flex; align-items: center; justify-content: center; width: 100%"
          >
            <span style="margin-left: 0.3em; align-self: center">תאריך וסת אחרון </span>
            <span class="t-field t-field--number" style="direction: rtl">
              <img src="../../assets/icons/date.svg" (click)="LMPDatepicker.open()" />
              <input
                [(ngModel)]="LMP"
                (ngModelChange)="onLmpChange()"
                class="t-field-text"
                [matDatepicker]="LMPDatepicker"
                [max]="maxDate"
              />
            </span>
            <mat-datepicker #LMPDatepicker></mat-datepicker>
            <span *ngIf="LMP" class="t-validation-wrap" style="display: flex; margin-right: 5%">
              <label> GA: </label>
              <span style="font-weight: bolder">{{ lmpGA(LMP) }}</span>
            </span>
          </div>
        </div>
        <div
          *ngIf="
            examCategory == 'Pregnancy' || examCategory == 'Fetal Echo'
              ? LMP && filterdClinicExamTypeAfterUserSelectCategory.length && examCategory
              : filterdClinicExamTypeAfterUserSelectCategory.length && examCategory
          "
          class="m-box"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              max-width: 400px;
            "
          >
            <span style="margin-left: 0.3em; align-self: center">בחרי בדיקה </span>
            <select
              class="t-select w100"
              style="padding-left: 1vh"
              [(ngModel)]="examTypeSelected"
              (ngModelChange)="onExamTypeChange()"
            >
              <option
                *ngFor="let e of filterdClinicExamTypeAfterUserSelectCategory | sortExamTypes"
                [value]="e.AutoIndex"
              >
                {{ e.examName }}
              </option>
            </select>
          </div>
        </div>
        <div
          class="m-box"
          *ngIf="examTypeSelected && hmo === 'Hmo' && getExamType(examTypeSelected) === 'Late Anatomy'"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="display: flex; align-items: center; justify-content: center; width: 100%"
          >
            האם זו תיהיה בדיקה ראשונה בהריון זה על חשבון הקופה:
            <label class="t-label-top">
              <input
                type="radio"
                [value]="true"
                class="custom-check -sq"
                name="firstExam"
                [(ngModel)]="firstExam"
                (ngModelChange)="
                  isFirstExamAnswered = true;
                  this.Price = null;
                  isprevExamHmoRefundAnswered = null;
                  prevExamHmoRefund = null;
                  prevExamHmo = null;
                  isPrevExamHmoAnswered = null
                "
              />
              <i class="customInput-display -sq"></i>
              <span>כן</span>
            </label>
            <label class="t-label-top">
              <input
                type="radio"
                [value]="false"
                class="custom-check -sq"
                name="firstExam"
                [(ngModel)]="firstExam"
                (ngModelChange)="
                  isFirstExamAnswered = true;
                  this.Price = null;
                  isprevExamHmoRefundAnswered = null;
                  prevExamHmoRefund = null;
                  prevExamHmo = null;
                  isPrevExamHmoAnswered = null
                "
              />
              <i class="customInput-display -sq"></i>
              <span>לא</span>
            </label>
          </div>
        </div>
        <div
          class="m-box"
          *ngIf="isFirstExamAnswered && !firstExam"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="display: flex; align-items: center; justify-content: center; width: 100%"
          >
            האם הסקירה הראשונה בהריון זה על חשבון הקופה
            <label class="t-label-top">
              <input
                type="radio"
                [value]="true"
                class="custom-check -sq"
                name="prevExamHmo"
                [(ngModel)]="prevExamHmo"
                (ngModelChange)="
                  isPrevExamHmoAnswered = true;
                  this.Price = null;
                  isprevExamHmoRefundAnswered = null;
                  prevExamHmoRefund = null
                "
              />
              <i class="customInput-display -sq"></i>
              <span>כן</span>
            </label>
            <label class="t-label-top">
              <input
                type="radio"
                [value]="false"
                class="custom-check -sq"
                name="prevExamHmo"
                [(ngModel)]="prevExamHmo"
                (ngModelChange)="
                  isPrevExamHmoAnswered = true;
                  this.Price = null;
                  isprevExamHmoRefundAnswered = null;
                  prevExamHmoRefund = null
                "
              />
              <i class="customInput-display -sq"></i>
              <span>לא</span>
            </label>
          </div>
        </div>
        <div
          class="m-box"
          *ngIf="isPrevExamHmoAnswered && !prevExamHmo"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="display: flex; align-items: center; justify-content: center; width: 100%"
          >
            האם בגין הבדיקה הפרטית בסקירה הראשונה היה החזר
            <label class="t-label-top">
              <input
                type="radio"
                [value]="true"
                class="custom-check -sq"
                name="prevExamHmoRefund"
                [(ngModel)]="prevExamHmoRefund"
                (ngModelChange)="isprevExamHmoRefundAnswered = true; this.Price = null"
              />
              <i class="customInput-display -sq"></i>
              <span>כן</span>
            </label>
            <label class="t-label-top">
              <input
                type="radio"
                [value]="false"
                class="custom-check -sq"
                name="prevExamHmoRefund"
                [(ngModel)]="prevExamHmoRefund"
                (ngModelChange)="isprevExamHmoRefundAnswered = true; this.Price = null"
              />
              <i class="customInput-display -sq"></i>
              <span>לא</span>
            </label>
          </div>
        </div>
        <div
          class="m-box"
          *ngIf="
            (isPrevExamHmoAnswered && prevExamHmo) || (isprevExamHmoRefundAnswered && prevExamHmoRefund)
          "
          style="display: flex; align-items: center; justify-content: center; height: 100%"
        >
          <p>ניתן לקבוע רק בדיקה פרטית</p>
        </div>
        <div
          *ngIf="
            filteredUsers.length > 0 &&
            examTypeSelected &&
            (!firstExamRequired ||
              (isprevExamHmoRefundAnswered && !prevExamHmoRefund) ||
              (isFirstExamAnswered && firstExam))
          "
          class="m-box"
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              max-width: 400px;
            "
          >
            <span style="margin-left: 0.3em; align-self: center">בחרי רופא מטפל</span>
            <select
              class="t-select w100"
              [(ngModel)]="doctorSelected"
              (ngModelChange)="Fetus = null; checkAvailableSlotsRange(); Price = null"
              style="padding-left: 1vh"
            >
              <option [value]="null">בחר רופא מהרשימה</option>
              <option *ngFor="let u of filteredUsers" [value]="u.UID">{{ u.Title }} {{ u.Name }}</option>
            </select>
          </div>
        </div>
        <div
          class="m-box"
          *ngIf="
            (examCategory == 'Pregnancy' || examCategory == 'Fetal Echo') &&
            doctorSelected &&
            (!firstExamRequired ||
              (isprevExamHmoRefundAnswered && !prevExamHmoRefund) ||
              (isFirstExamAnswered && firstExam))
          "
          style="
            direction: rtl;
            margin: 1em 0;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            class="w100"
            style="display: flex; align-items: center; justify-content: center; width: 100%"
          >
            עובר:
            <label class="t-label-top">
              <input
                type="radio"
                [value]="1"
                class="custom-check -sq"
                name="Fetus"
                [(ngModel)]="Fetus"
                (ngModelChange)="checkAvailableSlotsRange()"
              />
              <i class="customInput-display -sq"></i>
              <span>יחיד</span>
            </label>
            <label class="t-label-top">
              <input
                type="radio"
                [value]="2"
                class="custom-check -sq"
                name="Fetus"
                [(ngModel)]="Fetus"
                (ngModelChange)="checkAvailableSlotsRange()"
              />
              <i class="customInput-display -sq"></i>
              <span> תאומים</span>
            </label>
          </div>
        </div>

        <ng-container
          *ngIf="
            lmpValid &&
            doctorSelected &&
            examTypeSelected &&
            ID &&
            ((mobile && firstName && lastName) || patient.PID) &&
            (!(examCategory === 'Pregnancy' || examCategory === 'Fetal Echo') ||
              ((examCategory === 'Pregnancy' || examCategory === 'Fetal Echo') && Fetus))
          "
        >
          <div
            class="m-box controls-wrapper"
            *ngIf="(slotsAvailable === 'Loading' || !slotsAvailable) && !showExistingAppointmentMsg"
          >
            <div *ngIf="slotsAvailable === 'Loading'">
              <h3>אנחנו בודקים מועדים אפשריים לביצוע הבדיקה</h3>
              <img src="../../assets/images/Wedges.svg" />
            </div>
            <div *ngIf="!slotsAvailable">
              <h3>הרופאה שבחרת אינה זמינה בטווח הימים שבהם יש לבצע את הבדיקה.</h3>
              <h4 *ngIf="filteredUsers.length > 1">
                אם ברצונך לבדוק מועדים אפשריים אצל רופא אחר אנא בחרי רופא מטפל אחר
              </h4>
              <div style="display: flex; justify-content: space-evenly">
                <button class="blue-btn" style="height: fit-content" (click)="onShowMessage()">
                  להשארת פרטים וכניסה לרשימת המתנה
                </button>
                <!-- <button   class="blue-btn" (click)="leftDetails()">להשארת פרטים ולסיים </button>  -->
                <button
                  class="blue-btn"
                  style="height: fit-content"
                  (click)="
                    savePatientsAbandonedProcesses('No appointments available');
                    endScreen = true;
                    secondScreen = false
                  "
                >
                  לסיום ללא פרטים
                </button>
              </div>
            </div>
          </div>

          <div
            class="m-box"
            style="
              direction: rtl;
              margin: 1em 0;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            #messageDiv
            *ngIf="showMessage"
          >
            <div class="w100" style="display: flex; flex-direction: column; align-items: center">
              <textarea
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
                class="t-field-text w100"
                [(ngModel)]="Message"
                placeholder="ניתן לרשום כאן את ההודעה "
              ></textarea>
              <button class="blue-btn" (click)="leftDetails()">שלח וסיים</button>
            </div>
          </div>
          <ng-container *ngIf="!showExistingAppointmentMsg">
            <div
              class="m-box"
              *ngIf="slotsAvailable && slotsAvailable != 'Loading' && Price"
              style="
                direction: rtl;
                margin: 1em 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              "
            >
              <h3>מחיר הבדיקה שברצונך לבצע {{ Price }} ש"ח כולל מע"מ</h3>
              <!-- ======== SMS Consent (Start) ======== -->
              <div style="
                  direction: rtl;
                  margin: 1em 0;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  gap: 0.8em;
                  padding: 1em;
                  background-color: #f8f9fa;
                  border-radius: 8px;
                ">
                  <div style="display: flex; align-items: center; width: 100%; justify-content: center;">
                    <input type="checkbox" id="consentYes" [(ngModel)]="consentYes" (change)="onConsentYesChange()" style="margin-left: 0.5em; cursor: pointer;" />
                    <label for="consentYes" style="cursor: pointer; font-weight: 500;">
                      אני מאשר/ת קבלת מסרוני אישור ותזכורת לתור זה
                    </label>
                  </div>
                  <div style="display: flex; align-items: center; width: 100%; justify-content: center;">
                    <input type="checkbox" id="consentNo" [(ngModel)]="consentNo" (change)="onConsentNoChange()" style="margin-left: 0.5em; cursor: pointer;" />
                    <label for="consentNo" style="cursor: pointer; font-weight: 500;">
                      אני מעוניין/ת לקבוע תור ללא קבלת הודעות
                    </label>
                  </div>
                  <small style="color: #666; font-style: italic;">* יש לבחור אחת מהאפשרויות על מנת להמשיך</small>
                </div>
              <!-- ======== SMS Consent (End) ======== -->
              <div
                style="
                  direction: rtl;
                  margin: 1em 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <button (click)="savePatientAndRedirectToBooking()" class="blue-btn" [disabled]="showSmsConsent && !consentYes && !consentNo">
                  לבחירת תאריך ושעה רצויים
                </button>
                <!-- <button (click)="savePatientsAbandonedProcesses('After the price was displayed'); showMobile=true" class="orange-btn"> ברצוני לוותר על קביעת התור </button> -->
              </div>
              <h2 style="margin-top: 1em" *ngIf="showMobile">
                יש ליצור קשר עם המרפאה בטלפון {{ clinicPhone }}
              </h2>
            </div>
          </ng-container>

          <div
            class="m-box"
            *ngIf="showExistingAppointmentMsg"
            style="
              direction: rtl;
              margin: 1em 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <h3>{{ existingAppointmentMsg }}</h3>
            <button (click)="resetExitingAppointmentMessage()" class="orange-btn">בטל</button>
          </div>

          <div class="m-box" *ngIf="showPriceError && !showExistingAppointmentMsg">
            מחיר התור לא הוגדר במערכת יש ליצור קשר עם המרפאה בטלפון {{ clinicPhone }}
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="endScreen">
      <div
        class="m-box"
        style="
          direction: rtl;
          margin: 1em 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div style="display: flex; flex-direction: column; align-items: center">
          <h3 *ngIf="msgSaved">פרטייך נשמרו בהצלחה ניצור קשר בהקדם</h3>
          <h3>תודה ולהתראות</h3>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="showAppointmentsScreen && !onlyMessage">
      <div class="m-box" style="direction: rtl; margin: 1em 0">
        <table *ngIf="appointments.length" style="width: fit-content">
          <thead>
            <tr>
              <th>#</th>
              <th>
                {{ "appointments.gui.labels.Appointment" | translate }}
              </th>
              <th>
                {{ "appointments.gui.labels.Date" | translate }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let appointment of appointments | sortByDateTime; let i = index">
              <td>{{ i + 1 }}</td>
              <td>
                {{ appointment.isCustom ? appointment.examType : appointment.examName }}
              </td>
              <td>{{ appointment.aptTime | date : "dd.MM.yyyy HH:mm" }}</td>

              <td *ngIf="isFutureAppointment(appointment.aptTime)">
                <button
                  class="blue-btn fit-height"
                  (click)="updateAppointmentDate(appointment)"
                  [disabled]="patActivities > 3"
                >
                  שינוי תאריך
                </button>
              </td>
              <td *ngIf="isFutureAppointment(appointment.aptTime)">
                <button
                  class="orange-btn fit-height"
                  (click)="deleteAppointment(appointment.AutoIndex)"
                  [disabled]="patActivities > 3"
                >
                  {{ "appointments.gui.tooltips.Delete Appointment" | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <td>
          <button
            class="blue-btn fit-height"
            (click)="showAppointmentsScreen = false; secondScreen = true; checkExistingAppointment()"
            [disabled]="patActivities > 3"
          >
            קביעת תור חדש
          </button>
        </td>
      </div>
    </ng-container>
  </ng-container>
</main>
